jQuery(document).ready(function () {
  if (jQuery("free-shipping-bar.shipping-bar").css("--progress") == "1") {
    jQuery("span.shipping-bar__progress").css("border-color", "#45ba13");
    jQuery("free-shipping-bar.shipping-bar .shipping-bar__progress").addClass(
      "bar_custom"
    );
  } else {
    jQuery(
      "free-shipping-bar.shipping-bar .shipping-bar__progress"
    ).removeClass("bar_custom");
  }
});

jQuery(window).load(function () {
  if (jQuery("free-shipping-bar.shipping-bar").css("--progress") == "1") {
    jQuery("span.shipping-bar__progress").css("border-color", "#45ba13");
    jQuery("free-shipping-bar.shipping-bar .shipping-bar__progress").addClass(
      "bar_custom"
    );
  } else {
    jQuery(
      "free-shipping-bar.shipping-bar .shipping-bar__progress"
    ).removeClass("bar_custom");
  }
});

